<template>
  <div>
    <div class="search_content_textBox">
      <div class="search_content_textBox_top">검색결과</div>
      <div class="search_content_textBox_bottom">
        <span class="option">{{ returnBoardName() }}</span>에서
        <span class="resultCount">{{ total.total }}</span>개가 검색되었습니다.
      </div>
    </div>

    <div class="search_content_list">
      <div class="search_content_list_box" v-for='board in boardData' :key="`search${board.wr_id}`"
           @click="goDetail(board.wr_id)">
        <img class="search_content_list_box_img" :style="`background-image:url(${returnImage(board)})`">
        <div class="search_content_list_box_textBox">
          <div class="search_content_list_box_textBox_title">{{ board.wr_subject }}</div>
          <div class="search_content_list_box_textBox_text" v-html="decodeHtml(board.wr_content)"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";

export default {
  name: "BoardListSearchLayout",
  mixins: [imageOption],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    boardData: {
      type: Array,
      default: () => {
        return []
      }
    },
    total:0
  },
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    goDetail(idx) {
      if (!this.$route.query.type) {
        this.$router.push(`${this.$route.path}/${idx}`)
      }
      this.$router.push(`/${this.$route.query.type}/${idx}`)
    },
    returnImage(data) {
      return !util.isEmpty(data.File.MobileFile) ? `${data.File.MobileFile[0].org_url}?${this.setImageOptions(256, 184, 'jpg')}` : ''
    },
    returnBoardName() {
      let type = this.$route.query.type;
      switch (type) {
        case "business":
          return '주요사업'
        case "financial":
          return '재무보고'
        case "news":
          return '뉴스'
        case "donate":
          return '나눔&배움'
        case "album":
          return '앨범'
      }
    },
    decodeHtml(html = '') {
      let img_tag = /<IMG(.*?)>/gi;
      let video_tag = /<iframe(.*?)>(.*?)<\/iframe>/gi;
      html = html.replace(img_tag, "");
      html = html.replace(video_tag, "");

      return util.htmlDecode(html);
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>